import './pointer-events'; // ideally this should be async loaded when needed, but that wasn't working. Keeping it here for now.
import './global-this'; // ideally this should be async loaded when needed, but that wasn't working. Keeping it here for now.

import { shouldPolyfill as shouldPolyfillIntlLocale } from '@formatjs/intl-locale/should-polyfill';
import { shouldPolyfill as shouldPolyfillIntlGetCanonicalLocales } from '@formatjs/intl-getcanonicallocales/should-polyfill';
import { isServer } from '@/utilities';

export async function loadPolyfills() {
  if (isServer()) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    // @ts-expect-error -- declarations are not needed
    await import('intersection-observer');
  }

  if (!window.ResizeObserver) {
    // This polyfill is needed for @radix-ui/popover to work in old browsers
    const { install } = await import('resize-observer');
    install();
  }

  if (shouldPolyfillIntlLocale()) {
    await import('@formatjs/intl-locale/polyfill');
  }

  if (shouldPolyfillIntlGetCanonicalLocales()) {
    await import('@formatjs/intl-getcanonicallocales/polyfill');
  }
}

export async function polyfillIntlPlural(locale: string) {
  if (isServer()) {
    return;
  }

  // shouldPolyfill from @formatjs is not working properly, so do the check manually
  if (typeof Intl !== 'undefined' && !!Intl.PluralRules) {
    return;
  }

  const supportedLocaleImports: { [key: string]: () => Promise<any> } = {
    'nl-NL': () => import('@formatjs/intl-pluralrules/locale-data/nl'),
  };

  // Fallback to Dutch when locale is not supported
  if (!locale || !Object.keys(supportedLocaleImports).includes(locale)) locale = 'nl-NL';

  await import('@formatjs/intl-pluralrules/polyfill-force');
  await supportedLocaleImports[locale]();
}
